var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5122_4604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2C0 1.43269 1.43269 0 3.2 0H13.6L24 10.4V28.8C24 30.5673 22.5673 32 20.8 32H3.2C1.43269 32 0 30.5673 0 28.8V3.2Z",
    fill: "#008A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4H24L13.6 0V8C13.6 9.32548 14.6745 10.4 16 10.4Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 19.0001H17.9998M9.59976 19.2001V26.0001M5.99976 22.6001H17.9998M17.3998 15.4001H6.59976C6.26838 15.4001 5.99976 15.6687 5.99976 16.0001V25.6001C5.99976 25.9315 6.26838 26.2001 6.59976 26.2001H17.3998C17.7311 26.2001 17.9998 25.9315 17.9998 25.6001V16.0001C17.9998 15.6687 17.7311 15.4001 17.3998 15.4001Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5122_4604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSheet);
export default __webpack_public_path__ + "static/media/file-sheet.61b8e2cdadb6acd9623cbc51e108e890.svg";
export { ForwardRef as ReactComponent };